import { createStateSelectorHook } from 'src/lib/sweetState';
import { PerformanceStore } from 'src/store/performance';
import { ResourceStore } from 'src/store/resource';

const usePerformanceState = createStateSelectorHook(PerformanceStore, ['isCreatingResource']);
const useResourceState = createStateSelectorHook(ResourceStore, ['isCreatingResource']);

export const useIsCreatingResource = () => {
  // HINT: after extracting state/actions from PerformanceStore to ResourceStore,
  //   this isCreatingResource field was only one that was still used in PerformanceStore
  //   maybe later it can be moved as well
  const { isCreatingResource: isCreatingResourcePerformance } = usePerformanceState();
  const { isCreatingResource } = useResourceState();

  return isCreatingResourcePerformance || isCreatingResource;
};
